import { BodyLinkV3, TypographyV3 } from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';
import { Fragment } from 'react';

import {
  type JapaneseStore,
  japaneseStores,
  type Store,
} from '../_data/stores';

const JapanSizeInStore = (): JSX.Element => {
  const t = useTranslations();
  return (
    <div className="col-main lg:col-start-13 lg:mb-6" data-cy="japan-stores">
      {japaneseStores.map(({ id, storeName, stores }: JapaneseStore) => (
        <div key={id} className="mb-6">
          <TypographyV3 variant="body-large" weight="bold">
            {t(storeName)}:
            <span>
              &nbsp;
              {stores.map(
                ({ id: storeId, store, href }: Store, idx: number) => {
                  const comma = idx !== stores.length - 1 && (
                    <span className="font-light">,&nbsp;</span>
                  );
                  return (
                    <Fragment key={storeId}>
                      <BodyLinkV3
                        className="font-light"
                        href={href}
                        target="_blank"
                        rel="noopener noreferrer"
                        color="helsinkiBlue-dark"
                      >
                        {t(store)}
                      </BodyLinkV3>
                      {comma}
                    </Fragment>
                  );
                },
              )}
            </span>
          </TypographyV3>
        </div>
      ))}
    </div>
  );
};

export default JapanSizeInStore;
